export const ApiDepartments = {
    get: (params) => ({
        url: '/departments',
        method: 'GET',
        params
    }),
    create: (data) => ({
        url: '/departments',
        method: 'POST',
        data
    }),
    update: (data) => ({
        url: `/updateDepartment/`,
        method: 'PUT',
        data
    }),
    delete: (id) => ({
        url: `/departments/${id}`,
        method: 'DELETE'
    }),
};